/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @info Even if looks smelly, don't remove the "if" blocks
 * This will make sure the DefinePlugin will parse to literal booleans
 * and therefore making Terser rip out this blocks of code with the
 * actual configurations (which also uses the DefinePlugin).
 * This ensures no local or staging sensitive configuration will ever hit production.
 * @see {@link https://webpack.js.org/plugins/define-plugin/} for more info
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import { EnvironmentConfig } from '@olxeu-a2b/delivery-utils/typings/config';
import getParsedFlagsForEnvironment from './getParsedFlagsForEnvironment';

let config: EnvironmentConfig | null = null;

if (!process.env.A2B_ENV) {
  // eslint-disable-next-line no-console
  console.warn('Please provide the process.env.A2B_ENV variable. Falling back to "production"');
  config = process.env.A2B_PRODUCTION as any;
}

if (process.env.A2B_ENV === 'production') {
  config = process.env.A2B_PRODUCTION as any;
}
if (process.env.A2B_ENV === 'staging') {
  config = process.env.A2B_STAGING as any;
}
if (process.env.A2B_ENV === 'localhost') {
  if (typeof process.env.A2B_LOCALHOST === 'string') {
    /**
     * For unit tests we pass this as an env var rather
     * than transforming it out with webpack, so we need
     * to parse it
     */
    config = JSON.parse(process.env.A2B_LOCALHOST);
  } else {
    config = process.env.A2B_LOCALHOST as any;
  }
}

if (process.env.A2B_ENV === 'test') {
  config = process.env.A2B_TEST as any;
}

export function getConfig<K extends keyof EnvironmentConfig>(
  key: K,
): Readonly<EnvironmentConfig[K]>;

export function getConfig(): Readonly<EnvironmentConfig>;

/**
 * Gets configuration config from @olxeu-a2b/config
 * @param key {string}
 */

export function getConfig(key?: keyof EnvironmentConfig) {
  if (process.env.A2B_ENV !== 'production') {
    config.featureFlags = getParsedFlagsForEnvironment(config.featureFlags);
  }

  if (key) {
    return config[key] as Readonly<EnvironmentConfig[typeof key]>;
  }

  return config;
}
